import React from 'react';
import { useSelector, connect } from 'react-redux';
import { changeStepForm, STEPS } from '../../redux/actions/PasosFormulario';
import { addReservacion } from '../../redux/actions/Reservacion';
import FormReservacion from './FormReservacion';
import FormConfirmacionVehiculo from './FormConfirmacionVehiculo';
import PanelReservacion from './PanelReservacion';
import FinalPedido from './FinalPedido';
import Summary from './Summary';
import Carousel from '../utils/Carousel';
import TrackingBar from '../utils/TrackingBar';
import Footer from '../utils/Footer';
import { isLoading } from '../../redux/actions/Loading';
import { Redirect } from "react-router-dom";
import WhatsappComponent from '../utils/WhatsappComponent';


const Reservacion = ({ stepFoward, setReservacion, disabledRedirect }) => {

    const { stepForm, stepPrev } = useSelector(state => state.pasosReservacion);
    // const {  redirect, typeCar } = useSelector(state => state.pasosReservacion);
    const sucursales = useSelector(state => state.sucursales);

    //console.log("<<Reservacion>> stepForm " + stepForm);
    //console.log("<<Reservacion>> redirect " + redirect);
    //console.log("<<Reservacion>> typeCar " + typeCar);
    //console.log("<<Reservacion>> stepForm " + stepPrev);



    const submitReservacion = ({ LugarRecepcion, LugarDevolucion, FechaRecepcion, FechaDevolucion }) => {

        let fechaRecepcion = new Date(FechaRecepcion);
        let fechaDevolucion = new Date(FechaDevolucion);

        setReservacion({
            LugarRecepcion: sucursales.find(w => w.Id === LugarRecepcion),
            LugarDevolucion: sucursales.find(w => w.Id === LugarDevolucion),
            FechaRecepcion,
            FechaDevolucion,
            Dias: Math.ceil((fechaDevolucion.getTime() - fechaRecepcion.getTime()) / (1000 * 60 * 60 * 24))
        });

        stepFoward();

    }

    if (stepForm === "STEP_VEHICULO" && stepPrev === "STEP_RESERVACION") {
        //console.log(" redirect step vehiculo ");
        //disabledRedirect(false);
        return (<Redirect to="/escogetuvehiculo/sedan" />)
    }

    //console.log(" previo if paso: " + stepForm + " " + (STEPS.RESERVACION !== stepForm && STEPS.FINAL !== stepForm));
    if (STEPS.RESERVACION !== stepForm && STEPS.FINAL !== stepForm) {

        return (
            <>
                <TrackingBar />
                <div className="container-form">
                    <div className="row">
                        {
                            (stepForm === STEPS.CONFIRMACION) &&
                            <div className={`confirmacion-movil ${(stepForm === STEPS.CONFIRMACION) ? "col-sm-4" : "col-sm-3"}`}>
                                <FormConfirmacionVehiculo />
                            </div>
                        }
                        <div className={(stepForm === STEPS.CONFIRMACION) ? "col-sm-7" : "col-sm-8"}>
                            <PanelReservacion step={stepForm} />
                        </div>
                        {(stepForm !== STEPS.CONFIRMACION) && <div className="col-sm-1"></div>}
                        <div className={`confirmacion-web ${(stepForm === STEPS.CONFIRMACION) ? "col-sm-4" : "col-sm-3"}`}>
                            {(stepForm === STEPS.CONFIRMACION) ? <FormConfirmacionVehiculo /> : <Summary />}
                        </div>
                    </div>
                </div>
                <Footer />
            </>
        )
    } else {
        if (STEPS.FINAL === stepForm) {
            return <FinalPedido />
        } else {
            return <>
                {/* <FloatingWhatsApp
                avatar={avatarChat}
                phoneNumber={numeroWhatsapp}  // Número de teléfono en formato internacional
                accountName={nombreAsistente}
                chatMessage={fraseAsistente}
                statusMessage={estadoWhastapp}
                allowEsc={true} // Optional
                chatboxHeight={300}
                placeholder={fraseCaja}
                className="floating-whatsapp"
            /> */}
                <WhatsappComponent />
                <Carousel />
                <FormReservacion onSubmit={submitReservacion} />
            </>
        }
    }
}

const mapDispatchToProps = dispatch => {
    return {
        stepFoward: () => {

            dispatch(changeStepForm({ stepForm: STEPS.VEHICULO }));
            //dispatch(changeTypeRedirect(true));
            window.scrollTo(0, 0);

        },
        setReservacion: value => dispatch(addReservacion(value)),
        disabledRedirect: (booleanRedirect) => {
            //dispatch(changeTypeRedirect(booleanRedirect));
        },
        isLoading: value => dispatch(isLoading(value))
    }
}

export default connect(null, mapDispatchToProps)(Reservacion);